import { render, staticRenderFns } from "./BrandListAddNew.vue?vue&type=template&id=f03fc06a&"
import script from "./BrandListAddNew.vue?vue&type=script&lang=js&"
export * from "./BrandListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./BrandListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports